import React from 'react'
import { Link } from 'react-router-dom'
import Gallery from './galleryPage.jsx'

class Home extends React.Component {

    gallery = Gallery
    links = [
        {     href:"https://css-tricks.com/snippets/css/star-wars-crawl-text/", text: "Css Tricks - Star Wars Crawler" },
        {     href:"http://www.colourlovers.com/palettes", text: "Colour Lovers" },
        {     href:"https://philipwalton.github.io/solved-by-flexbox/", text: "Solved By Flexbox" },
        {     href:"http://www.datchley.name/promise-patterns-anti-patterns/", text: "Promise patterns and anti-patterns" },
        {     href:"http://getbem.com/", text: "Block Element Modifier CSS methodology" },
        {     href:"https://tympanus.net/codrops/css_reference/radial-gradient/", text: "Radial Gradients explained (shout out!)" },
        {     href:"http://ryanve.com/lab/dimensions/", text: "Useful viewport size web utility (shout out!)" },
        {     href:"https://www.youtube.com/watch?v=8aGhZQkoFbQ", text: "What the heck is the event loop anyway?" },
        {     href:"https://www.youtube.com/watch?v=zthIUs2w_c8", text: "Learn React with Kent C. Dodds" },
        {     href:"https://regex101.com/", text: "Regex101 - the standard for sharing regexen on the internet since 2000 something" },
        {     href:"https://stackoverflow.com/questions/1732348/regex-match-open-tags-except-xhtml-self-contained-tags", text: "Parsing HTML with Regular Expressions - A Practical Guide" },
        {     href:"http://www.responsinator.com/?url=sweaverd.com", text: "Responsinator.com - Are you responsive?" },

    ]

    render = () => {

        return (

            <div id="home">
                <div className="grid" id="homegrid">
                    <article>
                        <a id="aboutme" name="aboutme"></a>
                        <h2><i className="fas fa-child"><span>Hi!</span></i></h2>

                        <p>Hi. My name is Scott, and <span className="imageHover"><span>I'm</span><img src="images/myself2.jpg" alt="myself"/></span> a
                          software developer new to the Lynnwood, Washington area (via the East Coast).  Welcome to my personal website! Have a look around, and feel free to <a href="mailto:sweaver2112@gmail.com?subject=I need a web app, can you help me?"><span>inquire</span></a> about me building a web app for you.
                        </p>

                        <p>Update <span className="date">6/11/19</span>: I've converted my site to ReactJS!  Check out my <Link to="blog/converting-my-single-page-app-to-react">thoughts on the experience</Link>.</p>

                    </article>
                    <article>
                        <h2><i className="fab fa-github-alt"><span>Pictures of cats</span></i></h2>
                        <p>Please take a moment at this time to view my cats, <Link
                            to="#&gid=1&pid=hazeltonwilloughby"><span>Hazel</span></Link> and <Link
                                to="#&gid=1&pid=blackberry"><span>Blackberry</span></Link>, via the photo gallery! Optionally, please enjoy a <a onClick={window.myGlobals.gallery.randomGalleryPic} title="Enjoy a random photo from the gallery"><span>random</span></a> image.
    
	                    </p>
                    </article>
                </div>

                <div className="grid">
                    <article className="codepen">
                        <h2><i className="fab fa-codepen"><span>Code Pen</span></i></h2>
                        <p>A few pens. Bigger projects are over at the <Link to="/projects">projects page</Link>.</p>
                        <div className="codepen_links">
                            <a target="_blank" href="https://codepen.io/sweaver2112/full/rNBzXNy"><div>Pinwheel Spinner</div><img src="/public_images/codepens/pinwheel.png"></img></a>
                            <a target="_blank" href="https://codepen.io/sweaver2112/pen/WjNEJV"><div>Diffuse Sunlit background</div><img src="/public_images/codepens/sunlit.png"></img></a>
                            <a target="_blank" href="https://codepen.io/sweaver2112/full/BgzdZo"><div>Behind Pluto</div><img src="/public_images/codepens/pluto.png"></img></a>
                            <a target="_blank" href="https://codepen.io/sweaver2112/full/PoYXpxL"><div>Codepen Challenge: Black, White, and A's</div><img src="/public_images/codepens/AAAWallpapers.png"></img></a>
                            <a target="_blank" href="https://codepen.io/sweaver2112/full/GbZxGe"><div>Sullen moonlit background</div><img src="/public_images/codepens/moonlit.png"></img></a>
                            
                        </div>
                    </article>
                    <article className="links">
                        <h2><i className="fa fa-eye"><span title="Shout outs, external links help!">List of hpyerlinks</span></i></h2>

                        <p>Articles and tools that I found useful, interesting, or amusing.</p>
                        <ul style={{ width: "80%", margin: "auto", padding:"5px" }}>
                            {
                                this.links.map((link, i, arr)=>{
                                    return <li key={i}><a alt={link.text} target="_blank" rel="noopener noreferrer" href={link.href}><span>{link.text}</span></a></li>
                                })
                            }
                        </ul>
                    </article>

                </div>


            </div>



        )
    }
}
export default Home
